import React, { useMemo } from "react";
import { useSpecialHomeSlider } from "./hooks/useSpecialHomeSlider";

import { PropertyCardSkeleton } from "shared-components/Components/Property/PropertyCard/PropertyCardSkeleton";
import { EmblaCarousel } from "src/Components/EmblaCarousel";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";
import { ListingCard } from "shared-components/ViewFragments/SearchPage/ListingCard";
import { Button } from "shared-components/Components/Buttons/web";

interface SpecialHomeSliderProps {
	className?: string;
}

export const SpecialHomeSlider: React.FC<SpecialHomeSliderProps> = ({
	className = "",
}) => {
	const { loading, data, error, hasProperties } = useSpecialHomeSlider();
	const screen = useBreakpoint();

	const listings = useMemo(() => {
		return data.map((property) => {
			return {
				...property,
				singleImage: true,
				images: property?.images?.[0] ? [property?.images?.[0]] : [],
			};
		});
	}, [data]);

	// Don't show anything while loading or if there's an error
	if (loading || error) {
		return null;
	}

	// Only show if we have properties
	if (!hasProperties || !data.length) {
		return null;
	}


	return (
		<div className={`ultimos-ingresos-container ${className}`} style={{ marginTop: '40px', display: 'flex', flexDirection: 'column', alignItems: 'center'  }}>
            <img src="/icons/logo-finca-fest.svg" alt="logo-finca-test" width={300} height={100} />
			<EmblaCarousel 
				options={{
					slidesPerView: screen.xxl ? 6 : screen.xl ? 4 : screen.lg ? 3 : screen.md ? 2 : screen.sm ? 2 : 1,
					navigation: true,
					slidesToScroll: 1,
					align: 'center',
					breakpoints: {
						'(min-width:576px)': { slidesToScroll: 2 },
						'(min-width:768px)': { slidesToScroll: 2, align: 'start' },
						'(min-width:992px)': { slidesToScroll: 3, align: 'start' },
						'(min-width:1200px)': { slidesToScroll: 4, align: 'start' },
						'(min-width:1600px)': { slidesToScroll: 6, align: 'start' },
					}
				}}
				className="property-similars-cards"
				totalSlides={listings.length}
				title="fincafest"
			>
				{loading ?
					[...Array(6)].map((property, i) => {
						return (
							<div key={"ultimos_ingresos_skeleton_" + i} className={"similar"}>
								<PropertyCardSkeleton />
							</div>
						);
					}) :
					listings.map((property, i) => {
						return (
							<div key={"ultimos_ingresos_" + i} className={"similar"}>
								<ListingCard 
									shortCard={true} 
									data={property} 
									preloadImg={i < 3} 
									hideCta 
									staticGallery 
									showExpenses={false}
									showFairText={false}
								/>
							</div>
						);
					})
				}
			</EmblaCarousel>
			<Button
				style={{
					width: 'fit-content',
					alignSelf: 'center',
					marginTop: '1rem',
					background: '#ffd86a',
					color: '#3472b7',
					border: 'none',
					fontWeight: 'bold',
					fontSize: '18px'
				}}
				className="btn-primary"
				onClick={() => {
					window.location.href = "/proyectos-vivienda";
				}}
			>
				Ver todos las promos
			</Button>
		</div>
	);
};
